import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/marketing/edit1.svg'
import _imports_1 from '@/assets/marketing/minus-circle-black.svg'
import _imports_2 from '@/assets/marketing/add-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-55826e67"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tpl-form-content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"margin-top":"8px"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { style: {"margin-top":"8px"} }
const _hoisted_6 = {
  key: 0,
  class: "tpl-table"
}
const _hoisted_7 = { class: "tpl-table-thead" }
const _hoisted_8 = { class: "tpl-table-cell width-70" }
const _hoisted_9 = { class: "tpl-table-cell required" }
const _hoisted_10 = { class: "tpl-table-cell" }
const _hoisted_11 = { class: "tpl-table-cell" }
const _hoisted_12 = { class: "tpl-table-cell width-100" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tpl-table-cell tpl-detele-icon" }, null, -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "tpl-table-cell width-70" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tuozhuaipaixu" }, null, -1))
const _hoisted_17 = { class: "tpl-table-cell" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  src: _imports_1
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_22 = { class: "tpl-form-preview" }
const _hoisted_23 = { style: {"position":"absolute","z-index":"0","width":"321px","height":"695px"} }
const _hoisted_24 = ["src"]
const _hoisted_25 = { style: {"text-align":"center","border-bottom":"1px solid #CCCCCC66","margin-bottom":"16px","padding-bottom":"10px"} }
const _hoisted_26 = {
  key: 2,
  class: "btn-footer",
  style: {"padding":"0","background":"transparent","margin-top":"auto","margin-bottom":"16px"}
}
const _hoisted_27 = { style: {"max-height":"calc(100vh - 300px)","overflow-y":"auto"} }
const _hoisted_28 = ["src"]

import { ref, reactive, toRaw, computed, watchEffect, onBeforeMount, nextTick, PropType } from 'vue'
import { PlusOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { Form } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import draggable from 'vuedraggable'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { cloneDeep } from 'lodash-es'
import templateFields, { ofbuTemplateFields } from '@/utils/templateFields'
import { customerTypeEnum, genderEnum, linkRoleTypeEnum } from '@/views/marketing/commonEnum/dataConfig'
import { uploadFileApi } from '@/api/common'
import { templateDetail } from '@/api/marketing/marketingManage'
import { useCustomSelect } from './useCustomSelect'
import { useEnum } from './useEnum'
import { paramCodesEnum } from '../common'
import type { UnwrapRef } from 'vue'
import type { UploadFile } from 'ant-design-vue'
import type { TemplateFieldType, TemplateEditParams } from '@/typings/api/marketingManage'
import { url } from 'inspector'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'MainForm' }

interface FieldType {
  field: string
  label: string
  checked?: number[] | string[]
  required: boolean
  renderKey?: number
}
interface Option {
  label: string
  field: string
  disabled?: boolean
  type?: string
  attrs?: any
}
interface RootObject {
  label: string
  options: Option[]
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  status: {
    type: String,
    required: true,
    validator(value: string) {
      return ['view', 'edit', 'add'].includes(value)
    }
  },
  templateId: Number,
  subdomain: {
    type: String as PropType<'fbu' | 'lbu' | 'ofbu'>,
    required: true
  }
},
  emits: ['cancel', 'submit'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n()

const props = __props

const { showCustomSelect, customSelectOption } = useCustomSelect(props.subdomain)
const { adminAreaEnum, getAdminAreaList, paramCodeData, getByParamCodes, tagListEnum, getTagList } = useEnum()

const initGlobalConfig = {
  successImages: [] // 存数组，防止以后又要存多张图片
}

onBeforeMount(async () => {
  await getAdminAreaList()
  await getByParamCodes(props.subdomain)
  await getTagList()
  nextTick(() => {
    checkedFatmat()
  })
})

const draggableList = computed({
  get() {
    return dataForm.config as TemplateFieldType[]
  },
  set(val) {
    dataForm.config = val
  }
})

const fieldsFlatAll = (props.subdomain === 'ofbu' ? ofbuTemplateFields : templateFields).reduce((arr: any, item) => {
  let options = item.options
  // 此处云途筛选掉客户类别
  if (props.subdomain === 'lbu') {
    options = options.filter((item) => item.paramCode !== 'customerCategory')
  }
  arr = [...arr, ...options]
  return arr
}, [])
const fieldsEnum = ref<RootObject[]>(
  (props.subdomain === 'ofbu' ? ofbuTemplateFields : templateFields).map((item) => {
    // 此处云途筛选掉客户类别
    if (props.subdomain === 'lbu') {
      item.options = item.options.filter((option) => option.paramCode !== 'customerCategory')
    }

    item.options = item.options.map((i) => {
      i.label = i.lang ? t(i.lang) : i.label
      return i
    })
    item.label = item.lang ? t(item.lang) : item.label
    return item
  })
)
const dataForm = reactive<TemplateEditParams>({
  name: '',
  remark: '',
  background: '',
  fileList: [],
  type: 0,
  config: [
    {
      renderKey: Math.ceil(Math.random() * 100000000),
      field: '',
      label: '',
      required: false
    }
  ],
  globalConfig: cloneDeep(initGlobalConfig)
})
const formRules = reactive({
  name: [{ required: true, message: t('marketing.请输入模板名称') }],
  type: [{ required: true, message: t('marketing.请选择模板类型') }],
  fileList: [{ required: true, message: t('marketing.请上传背景图') }]
})
const useForm = Form.useForm
const { resetFields, validate, validateInfos } = useForm(dataForm, formRules)
const handleNewField = () => {
  const list = dataForm.config as TemplateFieldType[]
  list.push({
    renderKey: Math.ceil(Math.random() * 100000000),
    field: '',
    label: '',
    required: false
  })
}

// 根据 templateId 获取对应的模板数据，并将其转换为表单组件可用的数据格式
watchEffect(async () => {
  const templateId = props.templateId
  if (!templateId) {
    resetFields()
    dataForm.background = ''
    dataForm.id = undefined
    dataForm.templateId = undefined
    return
  }
  try {
    const { data } = await templateDetail({ templateId })
    const config = JSON.parse(data.config as string) as TemplateFieldType[] // 从 data 中解析出 config 字段并转换为指定类型

    const backgroundList = data.background.split(',') || []
    const fileList = backgroundList.map((item: string) => {
      return { url: item }
    }) // 根据是否存在 background 字段来设置 fileList，文件列表
    const globalConfig = data.globalConfig == null ? cloneDeep(initGlobalConfig) : JSON.parse(data.globalConfig) // 根据是否存在 globalConfig 字段来设置 globalConfig，全局配置

    isExpand.value = data.type === 0
    // 定义一个 formatData 对象，用来存储整合后的模板详情
    const formatData = {
      ...data,
      templateId: data.id,
      config: config.map((item) => ({
        label: item.label,
        field: item.field,
        checked: item.checked || undefined,
        required: item.required,
        renderKey: item.renderKey
      })),
      fileList,
      backgroundList,
      globalConfig
    }
    // 把整合后的模板详情赋值给 dataForm 对象
    Object.assign(dataForm, formatData)
  } catch (error) {
    console.error('Error getting template', error)
  }
})

/**
 * 监听可选字段
 */
watchEffect(() => {
  const checked = (dataForm.config as TemplateFieldType[]).map((e) => e.field)
  fieldsEnum.value.forEach((item) => {
    item.options.forEach((element) => {
      element.disabled = checked.includes(element.field)
    })
  })
})

const isActiveIndex = ref<number>()
const handleClick = (index: number) => {
  isActiveIndex.value = index
}
const editStatus = ref<boolean>(false)
const editableData: UnwrapRef<Record<string, FieldType>> = reactive({})
const edit = (key: number) => {
  editStatus.value = true
  editableData[key] = cloneDeep((dataForm.config as TemplateFieldType[]).filter((item) => key === item.renderKey)[0])
}
const handleDelete = (index: number) => {
  const list = dataForm.config as TemplateFieldType[]
  if (list.length > 1) {
    list.splice(index, 1)
  }
}

const handleType = () => {
  isExpand.value = dataForm.type === 1
}

const inputChange = (row: FieldType, value: string) => {
  row.label = value
}
const vFocus = {
  mounted: (el: HTMLElement) => el.focus()
}
const onBlur = (renderKey: number) => {
  editStatus.value = false
  delete editableData[renderKey]
}
const fieldslistAll = () => {
  return fieldsEnum.value.flatMap((ele) => ele.options)
}
const previewForm = computed(() => {
  const list = dataForm.config as TemplateFieldType[]
  const fieldsAll = fieldslistAll()
  return list.map((item) => {
    const fieldItem = fieldsAll.find((e) => e.field === item.field)
    if (fieldItem?.field === 'customerOffice') {
      fieldItem.attrs = {
        changeOnSelect: true,
        options: adminAreaEnum.value,
        fieldNames: { label: 'name', value: 'id' }
      }
    }
    if (fieldItem?.field === 'customerType') {
      fieldItem.attrs = {
        options: previewCustomSelectOption(customerTypeEnum, item.checked),
        fieldNames: { label: 'label', value: 'value' }
      }
    }
    if (fieldItem?.field === 'customerTag') {
      fieldItem.attrs.options = previewCustomSelectOption(tagListEnum.value, item.checked)
    }
    if (fieldItem?.field === 'contact.jobRole') {
      fieldItem.attrs = {
        options: previewCustomSelectOption(linkRoleTypeEnum, item.checked),
        fieldNames: { label: 'label', value: 'value' }
      }
    }
    if (fieldItem?.field === 'contact.sex') {
      fieldItem.attrs = {
        options: previewCustomSelectOption(genderEnum, item.checked),
        fieldNames: { label: 'label', value: 'value' }
      }
    }
    if (fieldItem?.field === 'business.cargoType') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].product],
        item.checked
      )
    }
    if (fieldItem?.field === 'business.salePlatform') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].channel],
        item.checked
      )
    }
    if (fieldItem?.field === 'business.warehouse') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].demand],
        item.checked
      )
    }
    if (fieldItem?.field === 'business.monthSales') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].monthly],
        item.checked
      )
    }
    if (fieldItem?.field === 'business.serviceNeeds') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].service],
        item.checked
      )
    }
    if (fieldItem?.field === 'business.salesCategory') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].category],
        item.checked
      )
    }
    if (fieldItem?.field === 'business.customerCategory') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].customerCategory],
        item.checked
      )
    }


    if (fieldItem?.field === 'business.shipments') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].shipments],
        item.checked
      )
    }
    if (fieldItem?.field === 'business.businessTypeSelect') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].businessTypeSelect],
        item.checked
      )
    }
    if (fieldItem?.field === 'business.salesChannel') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].salesChannel],
        item.checked
      )
    }
    if (fieldItem?.field === 'clientType') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].clientType],
        item.checked
      )
    }
    if (fieldItem?.field === 'channel') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].clueChannel],
        item.checked
      )
    }

    if (fieldItem?.field === 'business.regionalWarehouse') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].regionalWarehouse],
        item.checked
      )
    }
    // if (fieldItem?.field === 'business.cooperation') {
    //   fieldItem.attrs.options = previewCustomSelectOption(paramCodeData.value.zbu_existing_cooperation, item.checked)
    // }
    return Object.assign({}, fieldItem, {
      label: item.label || fieldItem?.label || '',
      checked: toRaw(item.checked) || undefined,
      required: item.required
    })
  })
})

const customRequest = (options: any) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData()
    formData.append('files', options.file)
    uploadFileApi(formData)
      .then((res: any) => {
        if (res.code === 200) {
          resolve(res.data)
        } else {
          message.error(res.message)
          reject(res.message)
        }
      })
      .catch((err) => {
        reject(err)
      })
  })
}
const beforeUpload = (file: UploadFile) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
  if (!isJpgOrPng) message.error(t('marketing.上传限制1'))
  const isLt10M = file.size && file.size / 1024 / 1024 < 10
  if (!isLt10M) message.error(t('marketing.上传限制2'))
  return isJpgOrPng && !!isLt10M
}
/**
 * 上传背景图
 */
const backgroundImagesRequest = (options: any) => {
  customRequest(options)
    .then((res: any) => {
      options.onSuccess(res, options.file)

      dataForm.fileList?.splice(-1)
      dataForm.fileList = [...(dataForm.fileList || []), { url: res[0] }]

      dataForm.backgroundList = dataForm.fileList?.map((item) => item.url).filter((item: string) => item) ?? []
      dataForm.background = dataForm.backgroundList.join(',')
    })
    .catch(() => {
      // dataForm.background = ''
      // dataForm.fileList = []
    })
}
const onRemove = (options: any) => {
  const index = dataForm.fileList?.indexOf(options, 0) ?? -1
  if (index > -1) {
    dataForm.fileList?.splice(index, 1)
    dataForm.backgroundList = dataForm.fileList?.map((item) => item.url).filter((item: string) => item) ?? []
    dataForm.background = dataForm.backgroundList.join(',')
  }
}

/**
 * 上传提交成功展示图
 */
const successImagesRequest = (options: any) => {
  customRequest(options)
    .then((res: any) => {
      dataForm.globalConfig.successImages = [{ url: res[0] }]
    })
    .catch(() => {
      dataForm.globalConfig.successImages = []
    })
}

const isExpand = ref<boolean>(true)
const handleExpand = (type: 'img' | 'form') => {
  if (dataForm.type === 1) return

  if (type === 'img' && isExpand.value) isExpand.value = false
  if (type === 'form' && !isExpand.value) isExpand.value = true
}

const handleSave = () => {
  if (dataForm.type === 0) { isExpand.value = true }
}
// const visible = ref<boolean>(false)
// const showModal = () => {
//   visible.value = true
// }
const previewSubmit = () => {
  message.warning(t('marketing.预览提示'))
}

const emit = __emit
// const handleCancel = () => emit('cancel')
// const handleSubmit = () => emit('submit')
const handleSubmit = () => {
  validate()
    .then(() => {
      const result: any[] = []
      const list = dataForm.config as TemplateFieldType[]
      const hasEmpty = list.some((item) => item.field === '')
      if (hasEmpty) return message.warning(t('marketing.完善表单提示'))
      // 判断是否有客户名称和联系方式
      const fieldArr = list.map((item) => item.field)
      if (
        fieldArr.includes('customerName') && (
          (props.subdomain === 'ofbu' && (fieldArr.includes('contact.mobile') || fieldArr.includes('contact.skype')))
          || (fieldArr.includes('contact.mobile') ||
          fieldArr.includes('contact.email') ||
          fieldArr.includes('contact.wechat') ||
          fieldArr.includes('contact.qq') ||
          fieldArr.includes('contact.tel'))
        )
      ) {
        list.forEach((ele) => {
          const item = fieldsFlatAll.find((e: any) => e.field === ele.field)
          result.push(Object.assign({}, item, ele))
        })
        emit('submit', toRaw(dataForm))
      } else {
        return message.warning(t('marketing.模板保存提示'))
      }
    })
    .catch((err) => {
      console.log('error', err)
    })
}

// 预览图片
function getBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}
const previewVisible = ref(false)
const previewImage = ref('')
const previewTitle = ref('')
const handlePreviewCancel = () => {
  previewVisible.value = false
  previewTitle.value = ''
}
const handlePreview = async (file: any) => {
  if (!file.url && !file.preview) {
    file.preview = (await getBase64(file.originFileObj)) as string
  }
  previewImage.value = file.url || file.preview
  previewVisible.value = true
  previewTitle.value = file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
}

// 过滤下拉框选项
const previewCustomSelectOption = (oldList: any[], newList?: number[] | string[]) => {
  if (oldList == null) return []
  if (newList == null || newList.length === 0) return oldList || []
  const list = newList.map((item) => {
    const find = oldList.find((e: any) => e.id === item || e.value === item)
    return toRaw(find)
  })
  return list.filter((e) => e != null) || []
}

// 已选择数据和禁用的选项处理（临时）
const checkedFatmat = () => {
  const typeObj = {
    'business.cargoType': 'zbu_product_type',
    'business.salePlatform': 'zbu_channel_detail',
    'business.warehouse': 'zbu_demand_info',
    'business.monthSales': 'zbu_monthly_sales',
    'business.serviceNeeds': 'zbu_service_demand'
    // 'business.cooperation': 'zbu_existing_cooperation'
  }
  for (const key in typeObj) {
    if (Object.prototype.hasOwnProperty.call(typeObj, key)) {
      const element = typeObj[key]
      const config = dataForm.config as TemplateFieldType[]
      config.forEach((item: any) => {
        if (item.field === key && item.checked && item.checked.length) {
          for (let i = item.checked.length - 1; i >= 0; i--) {
            const find = paramCodeData.value[element].find((e) => e.id === item.checked[i])
            if (!find) item.checked.splice(i, 1)
          }
        }
      })
    }
  }
}

__expose({ handleSubmit })

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_carousel = _resolveComponent("a-carousel")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tpl-form", { 'tpl-form-status__view': props.status === 'view' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, _mergeProps({
            label: _unref(t)('marketing.模板名称'),
            name: "name"
          }, _unref(validateInfos).name), {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                class: "width-60",
                value: dataForm.name,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.name) = $event)),
                valueModifiers: { trim: true },
                maxlength: 50,
                allowClear: "",
                disabled: props.status === 'view'
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }, 16, ["label"]),
          _createVNode(_component_a_form_item, _mergeProps({
            label: _unref(t)('marketing.模板类型'),
            name: "type"
          }, _unref(validateInfos).type), {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                disabled: props.status === 'view',
                value: dataForm.type,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.type) = $event)),
                onChange: handleType
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio, { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('marketing.APP模板1')) + " ", 1),
                      _createVNode(_component_a_tooltip, null, {
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('marketing.模板提示1')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(ExclamationCircleOutlined), { style: { fontSize: '14px', fontWeight: 'normal' } })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('marketing.APP模板2')) + " ", 1),
                      _createVNode(_component_a_tooltip, null, {
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('marketing.模板提示2')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(ExclamationCircleOutlined), { style: { fontSize: '14px', fontWeight: 'normal' } })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('marketing.Web模板')) + " ", 1),
                      _createVNode(_component_a_tooltip, null, {
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('marketing.模板提示3')), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(ExclamationCircleOutlined), { style: { fontSize: '14px', fontWeight: 'normal' } })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disabled", "value"])
            ]),
            _: 1
          }, 16, ["label"]),
          _createVNode(_component_a_form_item, {
            label: _unref(t)('marketing.说明'),
            name: "remark"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_textarea, {
                class: "width-60",
                value: dataForm.remark,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.remark) = $event)),
                maxlength: 2000,
                disabled: props.status === 'view'
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          (props.status !== 'view')
            ? (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({
                key: 0,
                label: dataForm.type === 2 ? _unref(t)('marketing.背景图建议2') : _unref(t)('marketing.背景图建议1'),
                name: "fileList"
              }, _unref(validateInfos).fileList), {
                default: _withCtx(() => [
                  _createVNode(_component_a_upload, {
                    "file-list": dataForm.fileList,
                    "onUpdate:fileList": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.fileList) = $event)),
                    action: "/base/resource/file/upload",
                    "list-type": "picture-card",
                    "max-count": dataForm.type === 0 ? 1 : 5,
                    name: "files",
                    "before-upload": beforeUpload,
                    customRequest: backgroundImagesRequest,
                    onRemove: onRemove,
                    onPreview: handlePreview
                  }, {
                    default: _withCtx(() => [
                      (dataForm.fileList && dataForm.fileList.length < (dataForm.type === 0 ? 1 : 5))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_unref(PlusOutlined)),
                            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('marketing.上传')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["file-list", "max-count"])
                ]),
                _: 1
              }, 16, ["label"]))
            : _createCommentVNode("", true),
          (props.status !== 'view')
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 1,
                label: _unref(t)('marketing.提交成功展示图'),
                name: "fileList"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_upload, {
                    "file-list": dataForm.globalConfig.successImages,
                    "onUpdate:fileList": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.globalConfig.successImages) = $event)),
                    action: "/base/resource/file/upload",
                    "list-type": "picture-card",
                    maxCount: 1,
                    name: "files",
                    "before-upload": beforeUpload,
                    customRequest: successImagesRequest,
                    onPreview: handlePreview
                  }, {
                    default: _withCtx(() => [
                      (dataForm.globalConfig.successImages.length < 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_unref(PlusOutlined)),
                            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('marketing.上传')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["file-list"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (props.status !== 'view')
        ? (_openBlock(), _createElementBlock("dl", _hoisted_6, [
            _createElementVNode("dt", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('marketing.排序')), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('marketing.字段名称')), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('marketing.展示选项')), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('marketing.显示字段名')), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('marketing.必填')), 1),
              _hoisted_13
            ]),
            _createVNode(_unref(draggable), {
              modelValue: draggableList.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((draggableList).value = $event)),
              "item-key": "renderKey",
              filter: ".not-allowed",
              class: "tpl-table-row_wrap"
            }, {
              item: _withCtx(({ element, index }) => [
                _createElementVNode("dd", {
                  class: _normalizeClass(["tpl-table-row", { active: isActiveIndex.value === index }]),
                  onClick: ($event: any) => (handleClick(index))
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", null, _toDisplayString(index + 1), 1),
                    _hoisted_16
                  ]),
                  _createElementVNode("div", {
                    class: "tpl-table-cell",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createVNode(_component_a_select, {
                      value: element.field,
                      "onUpdate:value": ($event: any) => ((element.field) = $event),
                      fieldNames: { value: 'field' },
                      placeholder: _unref(t)('marketing.选择字段名称'),
                      options: fieldsEnum.value
                    }, null, 8, ["value", "onUpdate:value", "placeholder", "options"])
                  ]),
                  _createElementVNode("div", {
                    class: "tpl-table-cell",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    (_unref(showCustomSelect)(element.field))
                      ? (_openBlock(), _createBlock(_component_a_select, {
                          key: 0,
                          value: element.checked,
                          "onUpdate:value": ($event: any) => ((element.checked) = $event),
                          fieldNames: { label: 'name', value: 'id' },
                          mode: "multiple",
                          "max-tag-count": "responsive",
                          placeholder: _unref(t)('marketing.展示所有选项'),
                          options: _unref(customSelectOption)(element.field)
                        }, null, 8, ["value", "onUpdate:value", "placeholder", "options"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString('--'))
                        ], 64))
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    (editStatus.value && editableData[element.renderKey])
                      ? _withDirectives((_openBlock(), _createBlock(_component_a_input, {
                          key: 0,
                          value: editableData[element.renderKey]['label'],
                          "onUpdate:value": ($event: any) => ((editableData[element.renderKey]['label']) = $event),
                          maxlength: 100,
                          onChange: ($event: any) => (inputChange(element, editableData[element.renderKey]['label'])),
                          onBlur: ($event: any) => (onBlur(element.renderKey))
                        }, null, 8, ["value", "onUpdate:value", "onChange", "onBlur"])), [
                          [vFocus]
                        ])
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(element.label || '--') + " ", 1),
                          _createElementVNode("img", {
                            class: "tpl-edit-icon",
                            src: _imports_0,
                            onClick: ($event: any) => (edit(element.renderKey))
                          }, null, 8, _hoisted_18)
                        ], 64))
                  ]),
                  _createElementVNode("div", {
                    class: "tpl-table-cell width-100",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createVNode(_component_a_switch, {
                      checked: element.required,
                      "onUpdate:checked": ($event: any) => ((element.required) = $event)
                    }, null, 8, ["checked", "onUpdate:checked"])
                  ]),
                  _createElementVNode("div", {
                    class: "tpl-table-cell tpl-detele-icon",
                    onClick: _withModifiers(($event: any) => (handleDelete(index)), ["stop"])
                  }, [
                    (dataForm.config.length > 1)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_20))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_19)
                ], 10, _hoisted_14)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (props.status !== 'view')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "tpl-add-button",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (handleNewField()))
          }, [
            _hoisted_21,
            _createElementVNode("p", null, _toDisplayString(_unref(t)('marketing.新增字段')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_a_carousel, { "dot-position": "top" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.backgroundList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item,
                class: "picture",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (handleExpand('img')))
              }, [
                _createElementVNode("img", { src: item }, null, 8, _hoisted_24)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      (isExpand.value || dataForm.type !== 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "form-content",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (handleExpand('form')))
          }, [
            _createElementVNode("h3", _hoisted_25, _toDisplayString(_unref(t)('marketing.填写资料')), 1),
            _createVNode(_component_a_form, {
              layout: "vertical",
              model: previewForm.value,
              colon: false,
              "label-col": { style: { width: '300px', 'white-space': 'normal', 'line-height': 1.2 } }
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previewForm.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_a_form_item, {
                    label: item.label,
                    rules: [{ required: item.required }],
                    key: index
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.type === 'ParamCodeCascader' ? ParamCodeCascader : item.type), _mergeProps({
                        appId: "cos_zbu",
                        props: item,
                        fieldNames: { label: 'name', value: 'id' },
                        placeholder: `${['AInput', 'ATextarea'].includes(item.type as string) ? _unref(t)('common.pleaseInput') : _unref(t)('common.pleaseSelect')}${item.label}`
                      }, item.attrs), null, 16, ["props", "placeholder"]))
                    ]),
                    _: 2
                  }, 1032, ["label", "rules"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["model"])
          ]))
        : _createCommentVNode("", true),
      (isExpand.value || dataForm.type !== 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "btn-footer",
            style: _normalizeStyle({ marginBottom: dataForm.type === 0 ? '3px': '19px', borderEndEndRadius: dataForm.type === 0 ? '0px' : '16px', borderEndStartRadius: dataForm.type === 0 ? '0px' : '16px' })
          }, [
            _createVNode(_component_a_button, {
              type: "primary",
              block: "",
              size: "large",
              shape: "round",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (previewSubmit()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('btn.提交')), 1)
              ]),
              _: 1
            })
          ], 4))
        : _createCommentVNode("", true),
      (!isExpand.value && dataForm.type === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createVNode(_component_a_button, {
              type: "primary",
              block: "",
              size: "large",
              shape: "round",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (handleSave()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('marketing.填写资料')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_modal, {
        visible: previewVisible.value,
        title: previewTitle.value,
        footer: null,
        onCancel: handlePreviewCancel
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("img", {
              alt: "example",
              style: {"width":"100%"},
              src: previewImage.value
            }, null, 8, _hoisted_28)
          ])
        ]),
        _: 1
      }, 8, ["visible", "title"])
    ])
  ], 2))
}
}

})